(() => {
  const SELECTOR = [
    '.kiki-collection-grid #FacetFiltersForm',
    '.kiki-collection-grid #FacetSortForm',
    '.kiki-collection-grid #FacetFiltersFormMobile',
    '.kiki-collection-grid #FacetFiltersFormDrawer'
  ].join(',');

  const applyForm = (form) => {
    if (!form || form.dataset.kikiSubmitting === 'true') return;

    const url = new URL(window.location.href);
    const controls = Array.from(form.elements || []).filter(
      (control) => control && control.name && !control.disabled
    );
    const names = new Set(controls.map((control) => control.name));

    names.forEach((name) => url.searchParams.delete(name));

    const formData = new FormData(form);
    formData.forEach((value, name) => {
      if (typeof value !== 'string') return;
      const normalized = value.trim();
      if (normalized !== '') url.searchParams.append(name, normalized);
    });

    url.searchParams.delete('page');

    form.dataset.kikiSubmitting = 'true';
    window.location.assign(url.toString());
  };

  const isFacetControl = (target) => {
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return false;
    if (!target.name) return false;
    return target.name === 'sort_by' || target.name.startsWith('filter.');
  };

  document.addEventListener(
    'input',
    (event) => {
      const target = event.target;
      if (!isFacetControl(target)) return;

      const form = target.closest('form');
      if (!form || !form.matches(SELECTOR)) return;

      // Stop Dawn's debounced facet handler before it reaches the form.
      // KIKI owns these collection controls and performs a deterministic URL navigation instead.
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      const type = String(target.type || '').toLowerCase();
      if (target instanceof HTMLSelectElement || type === 'checkbox' || type === 'radio') {
        event.preventDefault();
        applyForm(form);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!isFacetControl(target)) return;

      const form = target.closest('form');
      if (!form || !form.matches(SELECTOR)) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      applyForm(form);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(SELECTOR)) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      applyForm(form);
    },
    true
  );
})();
